import { apiClient } from './client';

export interface Operator {
  id: string;
  username: string;
  displayName: string;
  role: 'master' | 'admin' | 'operator' | 'viewer';
  tenantId: string;
  permissions: string[];
  isActive: boolean;
  lastLoginAt?: string;
  createdAt: string;
}

export interface CreateOperatorBody {
  username: string;
  password: string;
  displayName: string;
  role: 'master' | 'admin' | 'operator' | 'viewer';
  permissions?: string[];
}

export interface UpdateOperatorBody {
  displayName?: string;
  role?: 'master' | 'admin' | 'operator' | 'viewer';
  isActive?: boolean;
  permissions?: string[];
}

export interface OperatorHoursBody {
  start: string;
  end: string;
}

export interface OperatorHoursResponse {
  operatorId: string;
  start: string;
  end: string;
}

export const operatorsApi = {
  list: async () => {
    const { data } = await apiClient.get('/admin/operators');
    return data as Operator[];
  },

  create: async (body: CreateOperatorBody) => {
    const { data } = await apiClient.post('/admin/operators', body);
    return data as Operator;
  },

  update: async (id: string, body: UpdateOperatorBody) => {
    const { data } = await apiClient.patch(`/admin/operators/${id}`, body);
    return data as Operator;
  },

  remove: async (id: string) => {
    await apiClient.delete(`/admin/operators/${id}`);
  },

  setHours: async (id: string, body: OperatorHoursBody) => {
    const { data } = await apiClient.put(`/admin/operators/${id}/hours`, body);
    return data as OperatorHoursResponse;
  },
};
